<template>
    <div class="container-fluid text-left" style="font-size: small;">
      <div class="row">
        <div class="col-12">
          <h5>Terms and Conditions</h5>
          <p>These terms apply when you order from {{item.title}} on this website or mobile application. The restaurant receives your order on its till. Restaurant staff accept or reject the order there.</p>

          <h6>1. Information About Us</h6>
          <p><template v-if="item.registeredTitle != undefined && item.registeredTitle != null && item.registeredTitle.length > 0"><strong>{{item.registeredTitle}}</strong><br>trade as </template><strong>{{item.title}}</strong><br>{{item.contact}}<br><span v-html="item.addressText"></span></p>

          <h6>2. Your information</h6>
          <p>When you place orders we require a name and phone number in order to find or contact you regarding your orders.
            <br>Your phone number will be stored on your browser as soon as order is placed and the phone number stored on your browser will be used to find your order status and points awarded if we are providing point award service.
            <br>If you wish to reuse card payment session that was previously used in the future, the stored phone number will be used to get simple payment session.
            <br>If you wish to be notified about your order status in email form, we will take your email at placing order.
          </p>

          <h6>3. Order</h6>
          <p>When you place an order, it is sent to the restaurant's till. Restaurant staff accept or reject the order. You can see the result as the order status on this page. The restaurant may also call the phone number you gave, or send an email.</p>

          <h6>4. Delivery</h6>
          <p>When you place an order you will have the choice to place it as an ASAP Delivery or a Scheduled Delivery. For an ASAP Delivery, we will tell you an estimated delivery time for your Item before you place the order, but we will attempt delivery as soon as possible; you must therefore be available to accept delivery from the time you place the order. For a Scheduled Delivery, we will tell you the time when the Item is expected to be delivered; you must be available to accept delivery for ten minutes before and ten minutes after that time.</p>

          <h6>5. Cancellation</h6>
          <p>You may cancel an order without charge at any time before we have started preparing the food (order status is "in Kitchen"). If you wish to cancel an order before it becomes a "in kitchen" status, please contact us immediately.</p>
          <p>Unfortunately, despite our, and our driver’s best efforts, things do not always go to plan and factors such as traffic and weather conditions may prevent us from delivering your Item on time. If your order is more than 15 minutes late, and we haven’t notified you giving you the option to cancel your order, we will work with you to make things right unless you have caused the delay (e.g. because you gave us the wrong address or did not come to the door).</p>
          <p>We will attempt delivery at the address you provide to us when you place your order. If you need to change the delivery location after you have placed your order, we may be able to change to the address to an alternative one that is registered with your account if you let us know before the driver has been dispatched, and the new address is within the same zone as the address you originally ordered your Item to. If we cannot change the delivery address, you have the option to cancel the order, but if food preparation has started you will be charged the full price for the Item, and if the driver has been despatched you will also be charged for delivery.</p>
          <p>You will still be charged for the Item and for delivery in the event of a failed delivery if you have caused such failure for any reason. Reasons you might cause a delivery to fail include (but are not limited to):</p>
          <ul>
            <li>You do not come to the door, did not pick up the phone when the driver contacted you using the contact information you have provided us and/or you picked up the phone but then failed to provide access within a reasonable amount of time, and the driver is unable to find a safe location to leave the food.</li>
            <li>The driver refuses to deliver the Item to you in accordance with section 8 (Age Restricted Products).</li>
          </ul>

          <h6>6, Change</h6>
          <p>You may change an order without charge at any time before we have started preparing the food (order status is "in Kitchen"). If you wish to change an order before it becomes a "in Kitchen" status, please contact us immediately.</p>

          <h6>7. Refund</h6>
          <p>
            Cancellation after an order becomes a "in kitchen" status, we will not be able to refund you.
            We do our best to keep our food quality high. You have a legal right to receive goods which comply with their description, which are of satisfactory quality and which comply with any specific requirements you tell us about (and we agree to) before you place your order.
            If you believe that the Items you have been provided do not comply with these legal rights, please let us know.
            We may request a photograph showing the problem if it is something that can be seen by inspecting the items.
            We will provide a refund in respect of the affected part of the item, and also in respect of delivery if the whole order was affected, unless we have reasonable cause to believe that the problem was caused after delivery.
            The restaurant issues a refund from its till. A refund is made to the original payment method.</p>

          <h6>8. Age Restricted Products</h6>
          <p>We do not sell age-restricted products to under-age customers.</p>
          <p>For collection and orders handed over at the restaurant, staff will check the customer's age. If the customer looks under age, they will ask for photo ID before handing over the order.</p>
          <p>For a delivery order, the delivery person will check the customer's age. If the customer looks under age, they will ask for photo ID before handing over the order.</p>
        </div>
      </div>
    </div>
</template>

<script>

    export default {
        name: "TnC",
        props: {
            item: {
                type: Object,
                default: function() {
                    return{}
                }
            }
        },
        data() {
          return {

          }
        },
        created() {
        },
        mounted() {
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TnC.vue